import { ReactComponent as WarpcastIcon } from "../../../assets/warpcast-logo.svg";
import { ReactComponent as TwitterBlueIcon } from "../../../assets/x-logo.svg";
import { createFarcasterShareUrl } from "../../common/ShareButtons";
import { formatAmount } from "./utils";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export const ShareButton = _ref => {
  var _round$roundMetadata, _round$roundMetadata$, _round$roundMetadata2;
  let {
    round,
    tokenSymbol,
    totalUSDCrowdfunded,
    totalDonations,
    type
  } = _ref;
  const roundName = (_round$roundMetadata = round.roundMetadata) === null || _round$roundMetadata === void 0 ? void 0 : _round$roundMetadata.name;
  const tokenAmount = (_round$roundMetadata$ = (_round$roundMetadata2 = round.roundMetadata) === null || _round$roundMetadata2 === void 0 || (_round$roundMetadata2 = _round$roundMetadata2.quadraticFundingConfig) === null || _round$roundMetadata2 === void 0 ? void 0 : _round$roundMetadata2.matchingFundsAvailable) !== null && _round$roundMetadata$ !== void 0 ? _round$roundMetadata$ : 0;
  const shareText = `🌐 ${formatAmount(tokenAmount, true)} ${tokenSymbol} matching pool
📈 $${formatAmount(totalUSDCrowdfunded.toFixed(2))} funded so far
🤝 ${formatAmount(totalDonations, true)} donations
👀 Check out ${roundName}’s stats!
`;
  const twitterShareUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(shareText + window.location.href)}`;
  const farcasterShareUrl = createFarcasterShareUrl(encodeURIComponent(shareText), [window.location.href]);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: type === "TWITTER" ? /*#__PURE__*/_jsxs("button", {
      type: "button",
      onClick: () => window.open(twitterShareUrl, "_blank"),
      className: "w-full flex items-center justify-center gap-2 font-mono hover:opacity-70 transition-all shadow-sm border px-4 py-2 rounded-lg border-black hover:shadow-md",
      children: [/*#__PURE__*/_jsx(TwitterBlueIcon, {
        className: "h-6"
      }), /*#__PURE__*/_jsx("span", {
        className: "flex-shrink-0 text-sm",
        children: "Share on X"
      })]
    }) : /*#__PURE__*/_jsxs("button", {
      type: "button",
      onClick: () => window.open(farcasterShareUrl, "_blank"),
      className: "w-full flex items-center justify-center gap-2 font-mono hover:opacity-70 transition-all shadow-sm border px-4 py-2 rounded-lg border-black hover:shadow-md",
      children: [/*#__PURE__*/_jsx("span", {
        children: /*#__PURE__*/_jsx(WarpcastIcon, {
          className: "h-6"
        })
      }), /*#__PURE__*/_jsx("span", {
        className: "flex-shrink-0 text-sm",
        children: "Share on Warpcast"
      })]
    })
  });
};